import { CardBrand } from "../features/sales/types";

export const toCardDigits = (value: string) => value.replace(/\D/g, "");

export const isBetween = (value: number, min: number, max: number) =>
  value >= min && value <= max;

export const matchesAnyPrefixRange = (
  valueDigits: string,
  ranges: Array<[number, number]>,
  prefixLength: number,
) => {
  if (valueDigits.length < prefixLength) return false;
  const prefix = Number(valueDigits.slice(0, prefixLength));
  return ranges.some(([min, max]) => isBetween(prefix, min, max));
};

export const detectCardBrand = (value: string): CardBrand | null => {
  const digits = toCardDigits(value);
  if (!digits) return null;

  if (digits.startsWith("4")) return "visa";

  if (digits.length >= 2) {
    const prefix2 = Number(digits.slice(0, 2));
    if (isBetween(prefix2, 51, 55)) return "mastercard";
  }

  if (digits.length >= 4) {
    const prefix4 = Number(digits.slice(0, 4));
    if (isBetween(prefix4, 2221, 2720)) return "mastercard";
  }

  if (digits.startsWith("34") || digits.startsWith("37")) return "amex";

  if (digits.startsWith("606282") || digits.startsWith("3841"))
    return "hipercard";

  const eloRanges6: Array<[number, number]> = [
    [401178, 401179],
    [431274, 431274],
    [438935, 438935],
    [451416, 451416],
    [457393, 457393],
    [457631, 457632],
    [504175, 504175],
    [506699, 506778],
    [509000, 509999],
    [627780, 627780],
    [636297, 636297],
    [636368, 636368],
    [650031, 650033],
    [650035, 650051],
    [650405, 650439],
    [650485, 650538],
    [650541, 650598],
    [650700, 650718],
    [650720, 650727],
    [650901, 650978],
    [651652, 651679],
    [655000, 655019],
  ];

  if (matchesAnyPrefixRange(digits, eloRanges6, 6)) return "elo";

  return null;
};

export const isValidLuhn = (digits: string) => {
  let sum = 0;
  let shouldDouble = false;
  for (let i = digits.length - 1; i >= 0; i -= 1) {
    let n = Number(digits.charAt(i));
    if (Number.isNaN(n)) return false;
    if (shouldDouble) {
      n *= 2;
      if (n > 9) n -= 9;
    }
    sum += n;
    shouldDouble = !shouldDouble;
  }
  return sum % 10 === 0;
};

export const formatCardNumber = (digits: string) => {
  const clean = digits.replace(/\D/g, "").slice(0, 19);
  return clean.replace(/(\d{4})(?=\d)/g, "$1 ").trim();
};

export const formatExpiry = (digits: string) => {
  const clean = digits.replace(/\D/g, "").slice(0, 4);
  if (clean.length <= 2) return clean;
  return `${clean.slice(0, 2)}/${clean.slice(2)}`;
};

export const normalizeHolderName = (value: string) => {
  return value.toUpperCase().replace(/\d+/g, "");
};
